import { ShieldCheck } from "lucide-react";

/**
 * AdminPaywallBanner — drop this above any paywalled UI to tell platform
 * admins they have unrestricted access. Wrap any "pay" buttons in
 * `{!isAdmin && (...)}` and render this instead. Pair with `useIsAdmin()`
 * from `@/lib/auth`.
 *
 * Usage:
 *   const isAdmin = useIsAdmin();
 *   {isAdmin && <AdminPaywallBanner feature="Stealth Search reveal" />}
 *   {!isAdmin && <PayButton />}
 */
export default function AdminPaywallBanner({ feature = "this feature", note }) {
  return (
    <div
      className="border border-volt bg-[#0A101A] p-4 flex items-start gap-3"
      data-testid="admin-paywall-banner"
    >
      <ShieldCheck className="text-volt shrink-0 mt-0.5" size={20} strokeWidth={2} />
      <div className="text-sm">
        <div className="heading text-volt tracking-widest text-xs">
          PLATFORM ADMIN · UNRESTRICTED ACCESS
        </div>
        <div className="text-neutral-300 mt-1">
          You&apos;re signed in as a platform administrator, so {feature} is unlocked
          for you at no charge. Stripe checkout is bypassed.
          {note ? <span className="block text-neutral-500 mt-1 text-xs">{note}</span> : null}
        </div>
      </div>
    </div>
  );
}
